
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';
import { 
  User, 
  CreditCard, 
  FileText, 
  Settings, 
  LogOut,
  Key,
  Crown
} from 'lucide-react';

interface AccountMenuProps {
  onNavigateToProfile: () => void;
}

export const AccountMenu = ({ onNavigateToProfile }: AccountMenuProps) => {
  const { user, profile, signOut } = useAuth();

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="flex items-center space-x-2">
          <User className="h-4 w-4" />
          <span>{profile?.first_name || 'Mon Compte'}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuItem onClick={onNavigateToProfile}>
          <User className="h-4 w-4 mr-2" />
          Modifier mon profil
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={() => {/* TODO: Modal change password */}}>
          <Key className="h-4 w-4 mr-2" />
          Modifier le mot de passe
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={() => {/* TODO: Credits page */}}>
          <CreditCard className="h-4 w-4 mr-2" />
          Acheter des crédits
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={() => {/* TODO: Billing page */}}>
          <FileText className="h-4 w-4 mr-2" />
          Facturation
        </DropdownMenuItem>
        
        <DropdownMenuItem onClick={() => {/* TODO: Subscription page */}}>
          <Crown className="h-4 w-4 mr-2" />
          Gérer mon abonnement
        </DropdownMenuItem>
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem onClick={handleSignOut}>
          <LogOut className="h-4 w-4 mr-2" />
          Se déconnecter
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
